export class QDS0748 {
    EMP: string;
    ID_CAIXA: string;
    AGENCIA: string;
    DATA: string;
    DATA_FECHAMENTO: string;
    USUARIO: string;
    DATA_REC_DCTO: string;
    
}